<template>
    <div class="tickets-view-toolbar d-flex align-center flex-wrap pa-2">
        <v-toolbar-title v-if="showTitle" class="cadastro-toolbar__title" style="color: #4a4a4a">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn-toggle
            v-model="toggleIndex"
            mandatory
            dense
            class="mr-3"
        >
            <v-btn small @click="setViewMode('board')">
                <v-icon left small>mdi-view-column</v-icon>
                {{ $t('ticket.view.board') || 'Board' }}
            </v-btn>
            <v-btn small @click="setViewMode('list')">
                <v-icon left small>mdi-format-list-bulleted</v-icon>
                {{ $t('ticket.view.list') || 'Lista' }}
            </v-btn>
        </v-btn-toggle>
        <v-tooltip v-if="enableColumnOrderToggles && localViewMode === 'board'" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    outlined
                    class="mr-2"
                    :color="boardColumnsReversed ? 'primary' : undefined"
                    :aria-pressed="boardColumnsReversed"
                    @click="$emit('update:boardColumnsReversed', !boardColumnsReversed)"
                >
                    <v-icon small>mdi-swap-horizontal</v-icon>
                </v-btn>
            </template>
            <span>{{ $t('ticket.view.invertBoardColumns') }}</span>
        </v-tooltip>
        <v-tooltip v-if="enableColumnOrderToggles && localViewMode === 'list'" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    outlined
                    class="mr-2"
                    :color="listColumnsReversed ? 'primary' : undefined"
                    :aria-pressed="listColumnsReversed"
                    @click="$emit('update:listColumnsReversed', !listColumnsReversed)"
                >
                    <v-icon small>mdi-table-column-width</v-icon>
                </v-btn>
            </template>
            <span>{{ $t('ticket.view.invertListColumns') }}</span>
        </v-tooltip>
        <v-menu
            v-if="showSearch"
            v-model="filterMenuOpen"
            offset-y
            :close-on-content-click="false"
            min-width="220"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    outlined
                    class="filter-menu-activator flex-shrink-0"
                    :color="activeFilterCount > 0 ? 'primary' : undefined"
                >
                    <v-icon left small>mdi-filter-variant</v-icon>
                    {{ $t('ticket.filters.menu') || 'Filtrar' }}
                    <v-chip
                        v-if="activeFilterCount > 0"
                        x-small
                        class="ml-1"
                        color="primary"
                        text-color="white"
                    >{{ activeFilterCount }}</v-chip>
                </v-btn>
            </template>
            <v-list dense nav class="py-1">
                <v-menu
                    v-if="showTeamFilter && (teamList || []).length"
                    offset-x
                    right
                    :close-on-content-click="false"
                    @input="onTeamSubmenu"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.team') || 'Equipe' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <MultiplaEscolha
                            ref="teamSelect"
                            :items="teamList"
                            text="nome_equipe"
                            value="id_equipe"
                            :can-toggle-all="true"
                            :max-items="2"
                            :label="$t('ticket.filters.group.team') || 'Equipe'"
                            v-bind:selected-items.sync="modelTeamIds"
                        />
                    </v-card>
                </v-menu>
                <v-menu offset-x right :close-on-content-click="false" @input="onIdentificacaoSubmenu">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.identity') || 'Identificação' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <LazySelect
                            ref="identificacaoSelect"
                            get-url="getTicketslazy"
                            text="identificacao"
                            value="identificacao"
                            :label="$t('ticket.headers.id') || 'Ticket'"
                            @input="modelCodOrId = $event"
                        />
                    </v-card>
                </v-menu>
                <v-menu offset-x right :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.title') || 'Assunto' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <v-autocomplete
                            v-model="modelTitulo"
                            :items="optionsTitulo"
                            clearable
                            dense
                            hide-details
                            outlined
                            :label="$t('ticket.headers.title') || 'Título'"
                            :menu-props="{ maxHeight: 280, attach: true }"
                        />
                    </v-card>
                </v-menu>
                <v-menu
                    v-if="showClientFilter && (clientList || []).length"
                    offset-x
                    right
                    :close-on-content-click="false"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.client') || 'Cliente' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <v-autocomplete
                            v-model="modelClientId"
                            :items="clientList"
                            item-value="id_cliente"
                            item-text="nome_cliente"
                            clearable
                            dense
                            hide-details
                            outlined
                            :label="$t('ticket.filters.group.client') || 'Cliente'"
                            :menu-props="{ maxHeight: 280, attach: true }"
                        />
                    </v-card>
                </v-menu>
                <v-menu offset-x right :close-on-content-click="false" @input="onUnidadeSubmenu">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.unit') || 'Unidade' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <MultiplaEscolha
                            ref="unidadeSelect"
                            lazy
                            get-url="getUnidadeslazy"
                            text="descricao_unidade"
                            value="id_unidade"
                            :item-label="unidadeItemText"
                            :max-items="2"
                            :label="$t('ticket.headers.unidades') || 'Unidade'"
                            v-bind:selected-items.sync="modelUnidades"
                        />
                    </v-card>
                </v-menu>
                <v-menu offset-x right :close-on-content-click="false" @input="onAreaSubmenu">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.area') }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <MultiplaEscolha
                            ref="areaSelect"
                            lazy
                            get-url="getAreaslazy"
                            text="nome_area"
                            value="id_area"
                            :request-data="{ zona_risco: 0 }"
                            :item-label="areaItemText"
                            :max-items="2"
                            :label="$t('ticket.filters.group.area')"
                            v-bind:selected-items.sync="modelAreas"
                        />
                    </v-card>
                </v-menu>
                <v-menu offset-x right :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.agency') || 'Agência' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <v-autocomplete
                            v-model="modelAgencia"
                            :items="optionsAgencia"
                            clearable
                            dense
                            hide-details
                            outlined
                            :label="$t('ticket.headers.agencia') || 'Agência'"
                            :menu-props="{ maxHeight: 280, attach: true }"
                        />
                    </v-card>
                </v-menu>
                <v-menu offset-x right :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.requestType') || 'Tipo de solicitação' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <v-autocomplete
                            v-model="modelTipoSolicitacao"
                            :items="optionsTipoSolicitacao"
                            clearable
                            dense
                            hide-details
                            outlined
                            :label="$t('ticket.headers.tipoSolicitacao') || 'Tipo'"
                            :menu-props="{ maxHeight: 280, attach: true }"
                        />
                    </v-card>
                </v-menu>
                <v-menu offset-x right :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.pcd') || 'PCD' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <v-select
                            v-model="modelPcd"
                            :items="optionsPcd"
                            clearable
                            dense
                            hide-details
                            outlined
                            :label="$t('ticket.filters.group.pcd') || 'PCD'"
                            :menu-props="{ maxHeight: 280, attach: true }"
                        />
                    </v-card>
                </v-menu>
                <v-menu
                    v-if="showStatusFilter && (statusList || []).length"
                    offset-x
                    right
                    :close-on-content-click="false"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.status') || 'Status' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <v-select
                            v-model="modelStatusId"
                            :items="statusList"
                            item-value="id_status_ticket"
                            :item-text="statusItemText"
                            clearable
                            dense
                            hide-details
                            outlined
                            :label="$t('ticket.status.label') || 'Status'"
                            :menu-props="{ maxHeight: 280, attach: true }"
                        />
                    </v-card>
                </v-menu>
                <v-menu offset-x right :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.assignee') || 'Atribuído' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <v-autocomplete
                            v-model="modelUsuarioAtribuido"
                            :items="optionsUsuarioAtribuido"
                            clearable
                            dense
                            hide-details
                            outlined
                            :label="$t('ticket.headers.usuario') || 'Usuário'"
                            :menu-props="{ maxHeight: 280, attach: true }"
                        />
                    </v-card>
                </v-menu>
                <v-menu offset-x right :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.dates') || 'Data de inclusão' }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <div class="text-caption grey--text text--darken-1 mb-2">{{ $t('ticket.filters.dateFrom') || 'De' }}</div>
                        <v-menu v-model="menuDateFrom" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :value="fieldFilters.dtInclusaoFrom"
                                    readonly
                                    dense
                                    outlined
                                    hide-details
                                    clearable
                                    class="mb-3"
                                    :label="$t('ticket.filters.pickDate') || 'Data inicial'"
                                    prepend-inner-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click:clear.stop="patchFieldFilter('dtInclusaoFrom', null)"
                                />
                            </template>
                            <v-date-picker
                                :value="fieldFilters.dtInclusaoFrom"
                                no-title
                                scrollable
                                locale="pt-BR"
                                @input="onPickDateFrom"
                            />
                        </v-menu>
                        <div class="text-caption grey--text text--darken-1 mb-2">{{ $t('ticket.filters.dateTo') || 'Até' }}</div>
                        <v-menu v-model="menuDateTo" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :value="fieldFilters.dtInclusaoTo"
                                    readonly
                                    dense
                                    outlined
                                    hide-details
                                    clearable
                                    :label="$t('ticket.filters.pickDateEnd') || 'Data final'"
                                    prepend-inner-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click:clear.stop="patchFieldFilter('dtInclusaoTo', null)"
                                />
                            </template>
                            <v-date-picker
                                :value="fieldFilters.dtInclusaoTo"
                                no-title
                                scrollable
                                locale="pt-BR"
                                @input="onPickDateTo"
                            />
                        </v-menu>
                    </v-card>
                </v-menu>
                <v-menu offset-x right :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item v-bind="attrs" v-on="on" @click.stop>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ticket.filters.group.sla') }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-0">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </template>
                    <v-card class="filter-submenu-card pa-3" flat>
                        <v-select
                            v-model="modelSlaFaixa"
                            :items="optionsSlaFaixa"
                            dense
                            hide-details
                            outlined
                            prepend-inner-icon="mdi-timer-sand"
                            :label="$t('ticket.filters.resolutionExpected')"
                            :menu-props="{ maxHeight: 280, attach: true }"
                        />
                    </v-card>
                </v-menu>
                <v-divider class="my-1" />
                <v-list-item @click="clearAllFilters">
                    <v-list-item-icon class="my-0 mr-2">
                        <v-icon small color="error">mdi-filter-off</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('ticket.filters.clear') || 'Limpar filtros' }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-spacer></v-spacer>
        <v-btn
            v-if="showNewTicket"
            color="primary"
            small
            @click="$emit('new-ticket')"
        >
            <v-icon left small>mdi-plus</v-icon>
            {{ $t('ticket.createDialog.title') || 'Novo ticket' }}
        </v-btn>
    </div>
</template>

<script>
import { rotuloCatalogo } from '@/utils/ticketCatalogoLabel';
import LazySelect from '@/components/Selects/LazySelect.vue';
import MultiplaEscolha from '@/components/Selects/MultiplaEscolha.vue';
import { formatUnidadeLabel } from '@/utils/unidadeLabel';

export const EMPTY_TICKET_FIELD_FILTERS = {
    codOrId: null,
    titulo: null,
    unidades: [],
    areas: [],
    agencia: null,
    tipoSolicitacao: null,
    pcd: null,
    usuarioAtribuido: null,
    dtInclusaoFrom: null,
    dtInclusaoTo: null,
    /** Faixa de SLA atual do ticket (10H, 17H, 24H, 48H ou ATRASADO), calculada no servidor. */
    slaFaixa: null
};

/** Faixas de SLA, na ordem em que o ticket passa por elas. */
export const TICKET_SLA_FAIXAS = ['10H', '17H', '24H', '48H', 'ATRASADO'];

/** `YYYY-MM-DD` for the given Date in the browser's local calendar (midnight components). */
export function formatLocalYmd(d) {
    if (!d || !(d instanceof Date) || isNaN(d.getTime())) {
        return null;
    }
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

/**
 * Default inclusion-date window: calendar day prior through today (local).
 * Use for initial board/list load; "Limpar filtros" resets to EMPTY_TICKET_FIELD_FILTERS (all tickets).
 */
export function defaultTicketFieldFiltersLastTwoLocalDays() {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return normalizeTicketFieldFilters({
        dtInclusaoFrom: formatLocalYmd(start),
        dtInclusaoTo: formatLocalYmd(end)
    });
}

/** Ids de unidade (array, valor único ou objeto) em uma lista numérica sem repetição. */
function normalizeUnidadeIds(raw) {
    const out = [];
    const seen = new Set();
    const push = (v) => {
        if (v == null || v === '') return;
        const id = typeof v === 'object' && v.id_unidade != null ? v.id_unidade : v;
        const n = Number(id);
        if (!Number.isFinite(n) || seen.has(n)) return;
        seen.add(n);
        out.push(n);
    };
    if (Array.isArray(raw)) {
        raw.forEach(push);
    } else {
        push(raw);
    }
    return out;
}

export function normalizeTicketFieldFilters(raw) {
    const src = raw || {};
    const next = { ...EMPTY_TICKET_FIELD_FILTERS, ...src };
    // `unidade` (singular) é o formato antigo, de seleção única: ainda é aceito na entrada.
    next.unidades = normalizeUnidadeIds(src.unidades != null ? src.unidades : src.unidade);
    next.areas = normalizeUnidadeIds(src.areas);
    delete next.unidade;
    next.slaFaixa = TICKET_SLA_FAIXAS.includes(src.slaFaixa) ? src.slaFaixa : null;
    return next;
}

/** True quando o filtro PCD está preenchido (0 é valor válido, então não basta testar truthiness). */
function hasPcdFilter(v) {
    return v != null && v !== '';
}

export default {
    name: 'TicketsViewToolbar',
    components: {
        LazySelect,
        MultiplaEscolha
    },
    props: {
        viewMode: { type: String, default: 'board' },
        filterModel: {
            type: Object,
            default: () => ({
                search: '',
                statusId: null,
                clientId: null,
                teamIds: [],
                fieldFilters: { ...EMPTY_TICKET_FIELD_FILTERS }
            })
        },
        statusList: { type: Array, default: () => [] },
        clientList: { type: Array, default: () => [] },
        teamList: { type: Array, default: () => [] },
        /** Initial team selection when clearing filters (all teams or user's teams). */
        defaultTeamIds: { type: Array, default: () => [] },
        showTeamFilter: { type: Boolean, default: true },
        /** Autocomplete options computed by the server (getticketsquadro `opcoes`): titulos, agencias, tiposSolicitacao, usuariosAtribuidos. */
        opcoes: { type: Object, default: () => ({}) },
        showSearch: { type: Boolean, default: true },
        showStatusFilter: { type: Boolean, default: true },
        showClientFilter: { type: Boolean, default: false },
        showNewTicket: { type: Boolean, default: true },
        showTitle: { type: Boolean, default: true },
        title: { type: String, default: '' },
        enableColumnOrderToggles: { type: Boolean, default: false },
        boardColumnsReversed: { type: Boolean, default: false },
        listColumnsReversed: { type: Boolean, default: false }
    },
    data() {
        return {
            localViewMode: this.viewMode,
            toggleIndex: this.viewMode === 'list' ? 1 : 0,
            filterMenuOpen: false,
            menuDateFrom: false,
            menuDateTo: false
        };
    },
    computed: {
        fieldFilters() {
            return normalizeTicketFieldFilters(this.filterModel && this.filterModel.fieldFilters);
        },
        modelCodOrId: {
            get() {
                return this.fieldFilters.codOrId;
            },
            set(v) {
                this.patchFieldFilter('codOrId', v);
            }
        },
        modelTitulo: {
            get() {
                return this.fieldFilters.titulo;
            },
            set(v) {
                this.patchFieldFilter('titulo', v);
            }
        },
        modelUnidades: {
            get() {
                return this.fieldFilters.unidades;
            },
            set(v) {
                this.patchFieldFilter('unidades', normalizeUnidadeIds(v));
            }
        },
        modelAreas: {
            get() {
                return this.fieldFilters.areas;
            },
            set(v) {
                this.patchFieldFilter('areas', normalizeUnidadeIds(v));
            }
        },
        modelAgencia: {
            get() {
                return this.fieldFilters.agencia;
            },
            set(v) {
                this.patchFieldFilter('agencia', v);
            }
        },
        modelTipoSolicitacao: {
            get() {
                return this.fieldFilters.tipoSolicitacao;
            },
            set(v) {
                this.patchFieldFilter('tipoSolicitacao', v);
            }
        },
        modelPcd: {
            get() {
                return hasPcdFilter(this.fieldFilters.pcd) ? Number(this.fieldFilters.pcd) : null;
            },
            set(v) {
                this.patchFieldFilter('pcd', hasPcdFilter(v) ? Number(v) : null);
            }
        },
        modelUsuarioAtribuido: {
            get() {
                return this.fieldFilters.usuarioAtribuido;
            },
            set(v) {
                this.patchFieldFilter('usuarioAtribuido', v);
            }
        },
        modelSlaFaixa: {
            get() {
                return this.fieldFilters.slaFaixa;
            },
            set(v) {
                this.patchFieldFilter('slaFaixa', v);
            }
        },
        optionsSlaFaixa() {
            // Sem faixa escolhida (null) não filtra por SLA: a opção "Todos" representa esse estado.
            return [{ text: this.$t('ticket.sla.all'), value: null }].concat(
                TICKET_SLA_FAIXAS.map((faixa) => ({
                    text: faixa === 'ATRASADO' ? this.$t('ticket.sla.late') : this.$t('ticket.sla.option', { n: parseInt(faixa, 10) }),
                    value: faixa
                }))
            );
        },
        modelClientId: {
            get() {
                const m = this.filterModel;
                const v = m && m.clientId;
                return v != null && v !== '' ? v : null;
            },
            set(v) {
                this.emitTopFilter('clientId', v);
            }
        },
        modelStatusId: {
            get() {
                const m = this.filterModel;
                const v = m && m.statusId;
                return v != null && v !== '' ? v : null;
            },
            set(v) {
                this.emitTopFilter('statusId', v);
            }
        },
        modelTeamIds: {
            get() {
                const ids = this.filterModel && this.filterModel.teamIds;
                return Array.isArray(ids) ? ids : [];
            },
            set(v) {
                const list = Array.isArray(v) ? v.filter((id) => id != null && id !== '') : [];
                this.emitTopFilter('teamIds', list);
            }
        },
        allTeamIds() {
            return (this.teamList || []).map((e) => Number(e.id_equipe)).filter((n) => Number.isFinite(n));
        },
        optionsTitulo() {
            return (this.opcoes && this.opcoes.titulos) || [];
        },
        optionsAgencia() {
            return (this.opcoes && this.opcoes.agencias) || [];
        },
        optionsTipoSolicitacao() {
            return (this.opcoes && this.opcoes.tiposSolicitacao) || [];
        },
        optionsPcd() {
            return [
                { text: this.$t('selectOptions.yes') || 'Sim', value: 1 },
                { text: this.$t('selectOptions.no') || 'Não', value: 0 }
            ];
        },
        optionsUsuarioAtribuido() {
            return (this.opcoes && this.opcoes.usuariosAtribuidos) || [];
        },
        activeFilterCount() {
            let n = 0;
            const f = this.fieldFilters;
            if (f.codOrId) n++;
            if (f.titulo) n++;
            if (f.unidades.length) n++;
            if (f.areas.length) n++;
            if (f.agencia) n++;
            if (f.tipoSolicitacao) n++;
            if (hasPcdFilter(f.pcd)) n++;
            if (f.usuarioAtribuido) n++;
            if (f.dtInclusaoFrom) n++;
            if (f.dtInclusaoTo) n++;
            if (f.slaFaixa) n++;
            if (this.filterModel && this.filterModel.statusId != null && this.filterModel.statusId !== '') n++;
            if (this.filterModel && this.filterModel.clientId != null && this.filterModel.clientId !== '') n++;
            const sel = this.modelTeamIds.map((id) => Number(id)).filter((n) => Number.isFinite(n));
            const all = this.allTeamIds;
            if (all.length > 0 && sel.length > 0 && sel.length < all.length) n++;
            return n;
        }
    },
    watch: {
        viewMode(v) {
            this.localViewMode = v;
            this.toggleIndex = v === 'list' ? 1 : 0;
        }
    },
    methods: {
        setViewMode(mode) {
            this.localViewMode = mode;
            this.$emit('update:viewMode', mode);
        },
        unidadeItemText(item) {
            return formatUnidadeLabel(item);
        },
        statusItemText(item) {
            if (!item) return '';
            return rotuloCatalogo(this, item, 'status_ticket') || item.label || String(item.id_status_ticket || '');
        },
        syncUnidadeSelect() {
            const ref = this.$refs.unidadeSelect;
            if (!ref || typeof ref.setData !== 'function') return;
            ref.setData((this.modelUnidades || []).slice());
        },
        onUnidadeSubmenu(open) {
            if (!open) return;
            this.$nextTick(() => this.syncUnidadeSelect());
        },
        areaItemText(item) {
            if (!item) return '';
            return [item.cod_area, item.nome_area].filter(Boolean).join(' - ');
        },
        onAreaSubmenu(open) {
            if (!open) return;
            this.$nextTick(() => {
                const ref = this.$refs.areaSelect;
                if (ref && typeof ref.setData === 'function') ref.setData((this.modelAreas || []).slice());
            });
        },
        syncIdentificacaoSelect() {
            const ref = this.$refs.identificacaoSelect;
            if (!ref || typeof ref.setData !== 'function') return;
            if (this.modelCodOrId == null || this.modelCodOrId === '') {
                if (typeof ref.resetData === 'function') ref.resetData();
                return;
            }
            ref.setData(this.modelCodOrId);
        },
        onIdentificacaoSubmenu(open) {
            if (!open) return;
            this.$nextTick(() => this.syncIdentificacaoSelect());
        },
        syncTeamSelect() {
            const ref = this.$refs.teamSelect;
            if (!ref || typeof ref.setData !== 'function') return;
            ref.setData((this.modelTeamIds || []).slice());
        },
        onTeamSubmenu(open) {
            if (!open) return;
            this.$nextTick(() => this.syncTeamSelect());
        },
        emitFilters(nextPartial) {
            const base = this.filterModel && typeof this.filterModel === 'object' ? { ...this.filterModel } : {};
            const next = { ...base, ...nextPartial };
            next.fieldFilters = normalizeTicketFieldFilters(next.fieldFilters);
            this.$emit('update:filters', next);
        },
        patchFieldFilter(key, value) {
            const coerced = value === '' || value === undefined ? null : value;
            const fieldFilters = normalizeTicketFieldFilters({
                ...this.fieldFilters,
                [key]: coerced
            });
            this.emitFilters({ fieldFilters });
            if (key === 'dtInclusaoFrom') this.menuDateFrom = false;
            if (key === 'dtInclusaoTo') this.menuDateTo = false;
        },
        onPickDateFrom(v) {
            this.patchFieldFilter('dtInclusaoFrom', v || null);
            this.menuDateFrom = false;
        },
        onPickDateTo(v) {
            this.patchFieldFilter('dtInclusaoTo', v || null);
            this.menuDateTo = false;
        },
        emitTopFilter(key, value) {
            const coerced = value === '' || value === undefined ? null : value;
            this.emitFilters({ [key]: coerced });
        },
        clearAllFilters() {
            this.emitFilters({
                search: '',
                statusId: null,
                clientId: null,
                teamIds: (this.defaultTeamIds || []).slice(),
                fieldFilters: { ...EMPTY_TICKET_FIELD_FILTERS }
            });
            this.menuDateFrom = false;
            this.menuDateTo = false;
            this.$nextTick(() => {
                this.syncUnidadeSelect();
                this.syncIdentificacaoSelect();
                this.syncTeamSelect();
            });
        }
    }
};
</script>
<style scoped>
.cadastro-toolbar__title {
  min-width: 4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-menu-activator {
  max-width: 200px;
}
.filter-submenu-card {
  min-width: 280px;
  max-width: 340px;
}
</style>
